import * as React from 'react';
import { connect } from 'react-redux';
import ImageModal from '../General/ImageModal';
import { fetchSeller, editSeller, fetchIntegradores } from '../../actions/sellersActions';
import { putEstadoSellerApi, createImageSellerUrl, putSeller } from '../../api/axios';
import MiniSpinner from "../General/MiniSpinner";
import Cleave from 'cleave.js/react';
import { toast } from 'react-toastify';
import { getIdEstadoFromNombre } from '../../utilities/Seller/EstadoSeller';

class DatosBasicos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            isUpdatingEstado: false,
            srcImg: "",
            showImg: false
        };
        this.razonSocialInputRef = React.createRef();
    };

    componentDidMount() {
        this.props.fetchIntegradores();
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true });
        let seller = { ...this.props.seller };
        const { name, value } = event.target;

        if (name === "etiquetaSellerResumen") {
            const newValue = value.replace(/[^A-Za-z0-9]/g, "");
            seller[name] = newValue;
        } else {
            seller[name] = value;
        }
        this.props.editSeller(seller);
    }

    changeIntegrator = (event) => {
        this.setState({ didEdit: true });
        let seller = { ...this.props.seller };
        seller.integrador = { codigo: event.target.value };
        this.props.editSeller(seller);
    }

    clearImgInput = () => {
        let inputImg = document.getElementById("imgInput");
        inputImg.value = null;
    }

    showImgModal = (e, src) => {
        e.preventDefault();
        this.setState({ showImg: true, srcImg: src });
    }

    hideImgModal = () => {
        this.setState({ showImg: false });
    }

    addImg = async (e) => {
        const image = e.target.files[0];
        let req = createImageSellerUrl(image);
        req.then(res => {
            if (res != "Archivo incorrecto") {
                let seller = { ...this.props.seller, logo: res.url };
                this.props.editSeller(seller);
                this.clearImgInput();
            } else {
                toast.error(res)
            }
        }).catch(error =>
            toast.error("No se pudo cargar la imagen")
        );
    }

    updateEstadoSeller = (estado) => {
        let params = {
            listRequest: [
                {
                    idSeller: this.props.seller.codigo,
                    idEstado: getIdEstadoFromNombre(estado)
                }
            ]
        };

        let sellers = putEstadoSellerApi(params);

        sellers.then(res => {
            toast.success("Estado de seller modificado");
        }).catch(err => {
            (err.response?.data?.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("El estado no pudo modificarse");
        }).finally(() => {
            this.setState({ isUpdatingEstado: false });
        });
    };

    handleCheckboxChange = (field) => {
        const seller = { ...this.props.seller };

        if (field === 'estado') {
            this.setState({ isUpdatingEstado: true });
            seller.estado = seller.estado === "activo" ? "inactivo" : "activo";
            this.props.editSeller(seller);
            this.updateEstadoSeller(seller.estado);
        } else {
            seller[field] = !seller[field];
            this.props.editSeller(seller);

            if (['internacional', 'emisionFacturaA', 'tiendaActiva'].includes(field)) {
                let label = "";
                switch (field) {
                    case 'internacional': label = "Internacional"; break;
                    case 'emisionFacturaA': label = "Factura A"; break;
                    case 'tiendaActiva': label = "Tienda"; break;
                    default: label = field;
                }
                const status = seller[field] ? "activo" : "inactivo";

                putSeller(seller)
                    .then(res => toast.success(`${label} ${status}`))
                    .catch(err => {
                        toast.error(`Error al actualizar ${label}`);
                        seller[field] = !seller[field];
                        this.props.editSeller(seller);
                    });
            }
        }
    }

    renderCustomSwitch = (label, field) => {
        const { seller } = this.props;
        const isActive = seller[field];

        const switchContainerStyle = {
            position: 'relative',
            width: '40px',
            height: '20px',
            backgroundColor: 'white',
            border: `2px solid ${isActive ? 'green' : 'red'}`,
            borderRadius: '20px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: isActive ? 'flex-end' : 'flex-start',
            padding: '2px',
            transition: 'all 0.3s ease',
            marginRight: '10px'
        };

        const knobStyle = {
            width: '14px',
            height: '14px',
            backgroundColor: isActive ? 'green' : 'red',
            borderRadius: '50%',
            transition: 'all 0.3s ease'
        };

        const labelStyle = {
            marginBottom: '0',
            fontWeight: 'bold',
            color: '#333',
            cursor: 'pointer'
        };

        return (
            <div className="d-flex flex-column mr-4 mb-2" key={field} style={{ marginRight: '20px' }}>
                <div className="d-flex align-items-center">
                    <div
                        style={switchContainerStyle}
                        onClick={(e) => {
                            e.preventDefault();
                            this.handleCheckboxChange(field);
                        }}
                    >
                        <div style={knobStyle} />
                    </div>
                    <label
                        style={labelStyle}
                        onClick={(e) => {
                            e.preventDefault();
                            this.handleCheckboxChange(field);
                        }}
                    >
                        {label}
                    </label>
                </div>
                <small style={{ color: isActive ? 'green' : 'red', marginTop: '2px', fontWeight: 'bold', fontSize: '10px' }}>
                    {isActive ? 'Activo' : 'Inactivo'}
                </small>
            </div>
        );
    }

    render() {
        let { seller, userType } = this.props;
        let { showImg, srcImg } = this.state;

        let integradores = null;
        if (this.props.integradores != undefined) {
            integradores = this.props.integradores.map((item, index) => {
                return (
                    <option key={index} value={item.codigo}>{item.descripcion}</option>
                )
            })
        }

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">

                    <div className="form-group col-lg-6">
                        <label>Razón social</label>
                        <input
                            type="text"
                            className="form-control"
                            value={seller.razonSocial || ""}
                            onChange={this.myChangeHandler}
                            placeholder=""
                            name="razonSocial"
                            maxLength="100"
                            ref={this.razonSocialInputRef}
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>e-Mail contacto comercial</label>
                        <input
                            type="text"
                            className="form-control"
                            value={seller.email || ""}
                            onChange={this.myChangeHandler}
                            placeholder="usuario@dominio.com"
                            name="email"
                            maxLength="60"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Cuit</label>
                        <Cleave
                            className="form-control"
                            name="cuit"
                            value={seller.cuit || ""}
                            options={{ blocks: [2, 8, 1], delimiter: '-', numericOnly: true }}
                            onChange={this.myChangeHandler}
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Integrador</label>
                        <select
                            name="integrador"
                            className="form-control"
                            value={seller.integrador?.codigo ?? 1}
                            onChange={this.changeIntegrator}
                        >
                            {integradores}
                        </select>
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Nombre tienda</label>
                        <input
                            type="text"
                            className="form-control"
                            value={seller.nombreTienda ?? ""}
                            onChange={this.myChangeHandler}
                            placeholder=""
                            name="nombreTienda"
                            maxLength="50"
                        />
                    </div>

                    <div className="form-group col-lg-6 d-flex flex-column justify-content-center">
                        <label className="mb-2">Configuración</label>
                        <div className="d-flex flex-wrap">
                            {this.renderCustomSwitch("Internacional", "internacional")}
                            {this.renderCustomSwitch("Factura A", "emisionFacturaA")}
                            {this.renderCustomSwitch("Tienda Activa", "tiendaActiva")}
                        </div>
                    </div>

                    <div className="form-group col-lg-6">

                        <div className="form-group col-lg-6">
                            <label>Logo</label>
                            <div>
                                <input
                                    id="imgInput"
                                    className="m-t-10"
                                    type="file"
                                    name="imagen"
                                    onChange={this.addImg}
                                    accept="image/png, image/jpeg"
                                />
                            </div>
                        </div>

                        <div className="form-group col-lg-4">
                            <img
                                src={seller.logo}
                                style={{ cursor: 'pointer', width: "50%" }}
                                className="on mw-400px h-100 img-responsive"
                                onClick={e => this.showImgModal(e, seller.logo)}
                            />
                        </div>

                        <ImageModal
                            src={srcImg}
                            show={showImg}
                            onHide={this.hideImgModal}
                        />

                    </div>

                    <div className="form-group col-lg-6">
                        <label>Resumen Tarjeta Seller</label>
                        <input
                            type="text"
                            className="form-control"
                            value={seller.etiquetaSellerResumen ?? ""}
                            onChange={this.myChangeHandler}
                            name="etiquetaSellerResumen"
                            maxLength="8"
                            placeholder="Ej: Ab9Cd8E1 (máx. 8 caracteres)"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userType: state.general.userType,
    integradores: state.sellers.integradores,
    seller: JSON.stringify(state.general.generalObject) != "{}"
        ? state.general.generalObject
        : state.sellers.seller
    ,
});

export default connect(mapStateToProps, {
    fetchIntegradores,
    fetchSeller,
    editSeller
})(DatosBasicos);